import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'

interface Props {
  open: boolean
  onClose: () => void
  onDelete: () => void
}

const DeleteChallengeDialog = ({ open, onClose, onDelete }: Props) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete challenge?</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to delete this challenge?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onDelete}>Yes, delete</Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteChallengeDialog
